import React, { useCallback } from 'react';
import { TableCell, TableRow } from '@mui/material';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import FlexBox from 'components/common/FlexBox';
import { IconButton } from '@totalsoft/rocket-ui';

const ApprovalTypeItem = ({ data, onDelete }) => {
  const { t } = useTranslation();
  const historyContext = useHistoryWithContext();

  const handleEdit = useCallback(() => {
    historyContext.push(`/approvalTypes/${data.approvalTypeId}/${data.siteId}`);
  }, [historyContext, data]);

  return (
    <TableRow>
      <TableCell>{data.approvalTypeCode}</TableCell>
      <TableCell>{data.approvalTypeName}</TableCell>
      <TableCell>
        <FlexBox gap={0.5} justifyContent='end'>
          <IconButton color='primary' size='small' variant='text' type='edit' tooltip={t('Edit')} onClick={handleEdit} />
          <IconButton
            color='primary'
            size='small'
            variant='text'
            type='delete'
            tooltip={t('Delete')}
            onClick={() => onDelete(data.approvalTypeId, data.siteId)}
          />
        </FlexBox>
      </TableCell>
    </TableRow>
  );
};

ApprovalTypeItem.propTypes = {
  data: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default ApprovalTypeItem;
